(function (document) {
    var accessDenial = {
        $purchaseArea: null,
        init: function () {
            this.$purchaseArea = $(document).find('.scroll-into-view').closest('.purchaseArea');
            if (this.$purchaseArea.length > 0) {
                this.scroll();
            }
        },
        scroll: function () {
            var top = this.$purchaseArea.offset().top;
            window.setTimeout(function () {
                window.scrollTo({
                    top: top,
                    behavior: 'smooth',
                });
            }, 1000);
        },
    };

    UX.accessDenial = accessDenial;
})(document);
